export function getUniqueBy<T>(items: readonly T[], getKey: (item: T) => unknown): T[] {
  const itemByKey = new Map<unknown, T>();
  for (const item of items) {
    const key = getKey(item);
    if (!itemByKey.has(key)) itemByKey.set(key, item);
  }
  return [...itemByKey.values()];
}
